import * as S from '@effect/schema/Schema';
import { Array, Record, flow } from 'effect';
export const ConfigurationSet = S.Struct({
    name: S.String,
    structure: S.Number,
    conditions: S.Array(S.Number),
    options: S.Record({ key: S.String, value: S.Array(S.String) }),
});
export const options = (set) => set.options;
export const allOptionValues = flow(options, Record.values, Array.flatten);
